var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.855,
    cy: 14.0008,
    rx: 13.0728,
    ry: 12.6473,
    fill: "#8C30F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8622 20.75C31.7324 17.0221 31.7324 10.9779 27.8622 7.25C23.9919 3.52208 17.7169 3.52207 13.8466 7.25C9.97635 10.9779 9.97635 17.0221 13.8466 20.75C17.7169 24.4779 23.9919 24.4779 27.8622 20.75Z",
    fill: "#D6B1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6322 13.4733C27.8345 13.4733 27.9996 13.3092 27.9879 13.1072C27.9382 12.2535 27.7154 11.4162 27.3307 10.6437C26.8911 9.76102 26.2515 8.98556 25.4595 8.37495C24.6675 7.76434 23.7434 7.3343 22.7559 7.11678C21.8858 6.92512 20.9862 6.90282 20.1092 7.04986C19.9139 7.0826 19.7931 7.27628 19.8388 7.46897C19.8834 7.65778 20.0714 7.77463 20.2629 7.74344C21.0354 7.61761 21.8272 7.63905 22.5933 7.80781C23.4734 8.00167 24.297 8.38497 25.003 8.9292C25.7089 9.47343 26.2789 10.1646 26.6707 10.9513C27.0076 11.6279 27.2053 12.3601 27.254 13.1073C27.2672 13.3092 27.4299 13.4733 27.6322 13.4733Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10045 8.48178C8.18028 7.75884 7.65569 7.09585 6.93001 7.14476C6.32029 7.18586 5.7163 7.30208 5.13198 7.492C4.12875 7.81808 3.20651 8.35391 2.42661 9.06385C1.64671 9.77379 1.02704 10.6416 0.60881 11.6094C0.190585 12.5773 -0.0166003 13.6231 0.00103865 14.6772C0.0186776 15.7313 0.260736 16.7696 0.711111 17.723C1.16149 18.6763 1.80985 19.5229 2.61307 20.2064C3.41628 20.8899 4.35594 21.3946 5.36951 21.687C5.95984 21.8572 6.56736 21.9532 7.17808 21.9739C7.90502 21.9986 8.40717 21.3184 8.30319 20.5985C8.19924 19.8788 7.52347 19.3985 6.80255 19.3034C6.56575 19.2721 6.33102 19.2232 6.10035 19.1567C5.44627 18.968 4.8399 18.6423 4.32158 18.2012C3.80325 17.7602 3.38486 17.2139 3.09422 16.5986C2.80359 15.9834 2.64739 15.3134 2.63601 14.6332C2.62462 13.9529 2.75832 13.2781 3.02821 12.6535C3.29809 12.0289 3.69798 11.4689 4.20126 11.0108C4.70454 10.5527 5.29967 10.2069 5.94706 9.99648C6.17536 9.92227 6.40831 9.8655 6.64392 9.82637C7.36128 9.70723 8.02063 9.20457 8.10045 8.48178Z",
    fill: "#8C30F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVcIcon);
export default __webpack_public_path__ + "static/media/vc-icon.da65eb2c086ff243837f2444c635d333.svg";
export { ForwardRef as ReactComponent };